<div id="main" class="myw-content iom-bgclr d-flex flex-column flex-fill">
  <!-- navbar -->
  <div class="myw-navbar">
    <div class="myw-inner myw-container d-flex flex-wrap">
      <nav *ngIf="userType == 1" class="breadcrumb align-self-center pt-3" aria-label="breadcrumb">
        <a (click)="navigateToProposalSummary()" style="cursor:pointer;" title="Proposal Summary"><img
            src="assets/images/back.png" alt="Back" class="myw-icon mr-3" /></a>
      </nav>
      <nav class="nav nav-tabs">
        <a href="javascript:;" (click)="isActiveDD()" id="activedd" class="nav-item nav-link active">Active Deepdives
        </a>
        <a href="javascript:;" (click)="isInActiveDD()" id="inactivedd" class="nav-item nav-link">Inactive Deepdives</a>
        <!-- <a href="javascript:;" *ngIf="iomservice.isManualUpload" (click)="manualUpload()" id="manualUpload" class="nav-item nav-link">Manual Upload</a> -->
      </nav>      
        <div *ngIf="envData.EnableDownTime == true" class="scrolling-text" [@scroll]="state" (@scroll.done)="scrollDone()" [ngStyle]="{'color': 'red'}">
          Application will be down from {{this.startTime}} IST - {{this.endTime}} IST on {{this.downTimeDate}} due to deployment activity
        </div>      
    </div>
  </div>
  <div class="myw-inner myw-container position-relative"> 
    <!-- Try Now Section -->
    <div class="iom-try-now-section">
      <div class="iom-try-now-content">
        <div class="ion-try-header">
          <a href="javascript:;" class="iom-try-close"><img src="assets/images/back.png" alt="Back" class="myw-icon"></a>
          <div class="-title">Feature/Defect Updates</div>
        </div>
        <div class="iom-try-body">
          <p>{{envData.NewFeatureDisplayTop}}</p>
          <p>{{envData.NewFeatureDisplayMid}}</p>
          <p>{{envData.NewFeatureDisplayBottom}}</p>
        </div>
      </div>
      <a href="javascript:;" class="iom-try-now text-decoration-none">
        <span>Try it now</span>
      </a>
    </div>
    <div class="d-flex pt-4 pb-3 align-items-center">
      <h1 *ngIf="showcharts" class="fs-16 text-primary" style="cursor: pointer;">{{ddlabel}}</h1>
      <div class="align-self-center ml-auto flex-wrap d-flex">
        <!-- <a href="javascript:;" class="iombtn-icon mr-2"><img src="assets/images/search-icon.png" alt="" style="cursor: pointer;"
            class="myw-icon mr-2">Search</a> -->
            <div [ngClass]="{'disabled': isDisabledLanguage == true}" class="dropdown iom-drop-body d-flex mr-2">
              <span class="text-nowrap align-self-center myw-600">Language Selected : </span>
                  <select class="form-control" [(ngModel)]='selectedStdLanguage'
                                (change)="GetSelectedLanguage($event)">
                                    <!-- <option value="All">All</option> -->
                                    <option *ngFor="let t of LanguageList"
                                        [value]="t">
                                        {{t}}</option>
                                </select>
          </div>
        <div class="dropdown iom-drop-body d-flex">
          <a href="javascript:;" class="myw-login iom-drop-item dropdown-toggle iombtn-icon mr-2" role="button"
            data-bs-display="static" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="status"
            title="Search" (click)="clickeSearchFilter();">
            <img src="assets/images/search-icon.png" alt="Search" class="myw-icon mr-2" />Search
            <span class="sr-only">Search</span>
          </a>
          <div class="dropdown-menu iomsearch-bar" aria-labelledby="search">
            <form class="px-4 py-3" autocomplete="off">
              <div class="form-group mb-0">
                <div class="input-group">
                  <input type="text" class="form-control control-border" (keyup)="getDeepDive($event, true)"
                    placeholder="Search deepdive" name="searchDeepDive" [(ngModel)]="searchText">
                  <!-- <input type="text" class="form-control" placeholder="Search"> -->
                  <div class="input-group-append">
                    <button class="btn iom-transparent border-0" type="button"><img src="assets/images/search-icon.png"
                        alt="" (click)="getDeepDive($event, true)"></button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div (clickOutside)="onClickedOutside($event)" [ngClass]="{'show':displayCal}"
          class="dropdown iom-drop-body dropright d-flex">
          <a href="javascript:;" class="myw-login iom-drop-item iombtn-icon mr-2" role="button"
            (click)="displayCalendar()" data-bs-display="static" aria-haspopup="true" aria-expanded="false"
            id="modifiedDate" title="Modified Date">
            <img src="assets/images/calender-icon.svg" alt="Modified Date" class="myw-icon mr-2"
              style="cursor: pointer;" />Modified Date
            <span class="sr-only">Modified Date</span>
          </a>
          <!-- <div class="form-group">
            <label class="sr-only">Create Date / Modified Date</label>
            <div class="input-group input-group-border iom-datepicker">
              <input type="text" (dateSelect)="getDeepDivebyDate($event)"
                (keyup.backspace)="getDeepDivebyDate1($event)" [(ngModel)]="selectedDate" class="form-control"
                placeholder="Created Date Or Modified Date" ngbDatepicker #d1="ngbDatepicker" />
              <div class="input-group-append ">
                <button (click)="d1.toggle()" style="cursor: pointer;" class="btn" type="button"><img
                    src="assets/images/cal.svg" alt=""></button>
              </div>
            </div>
          </div> -->
          <div [ngClass]="{'show':displayCal}" class="dropdown-menu iomcalender" aria-labelledby="modifiedDate">
            <form class="px-4 py-3">
              <div class="form-group">
                <div class="input-group input-group-border iom-datepicker">
                  <input type="text" readonly onkeydown="return false" (dateSelect)="getDeepDivebyStartDate($event)"
                    (keyup.backspace)="getDeepDivebyDate1($event)" name="startDate" [(ngModel)]="selectedDate1"
                    class="form-control" placeholder="From : Select Date" ngbDatepicker #d1="ngbDatepicker">
                  <div class="input-group-append">
                    <button (click)="d1.toggle()" class="btn iom-transparent border-0" type="button"
                      style="cursor: pointer;"><img src="assets/images/calender-icon.svg" alt=""
                        style="cursor: pointer;"></button>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group input-group-border iom-datepicker">
                  <input type="text" id="Enddate" readonly (dateSelect)="getDeepDivebyEndDate($event)"
                    (keyup.backspace)="getDeepDivebyDate2($event)" name="endDate" [(ngModel)]="selectedDate2"
                    class="form-control" placeholder="To : Select Date" ngbDatepicker #d2="ngbDatepicker">
                  <div class="input-group-append">
                    <button (click)="d2.toggle()" class="btn iom-transparent border-0" type="button"
                      style="cursor: pointer;"><img src="assets/images/calender-icon.svg" alt=""
                        style="cursor: pointer;"></button>
                  </div>
                </div>
              </div>
              <!-- <div class="d-flex">
                <div class="iom-calender"></div>
              </div> -->
              <div class="d-flex align-items-center justify-content-center">
                <button type="button" class="btn btn-secondary fs-12 mr-4"
                  (click)="clearAllbasedonSelectedDated($event)">Clear All</button>
                <button type="button" class="btn btn-primary fs-12"
                  (click)="getDDbasedonSelectedDates($event, true)">Apply</button>
              </div>
            </form>
          </div>
        </div>
        <div class="dropdown iom-drop-body d-flex">
          <a href="javascript:;" class="myw-login iom-drop-item dropdown-toggle iombtn-icon mr-2" role="button"
            data-bs-display="static" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="status"
            title="Status" (click)="clickStatusFilter();">
            <img src="assets/images/status.svg" alt="Status" class="myw-icon mr-2"
              style="cursor: pointer;" />Status<span class="sr-only">Status</span>
          </a>
          <div class="dropdown-menu" aria-labelledby="status">
            <div class="dropdown-body1 iom-drop-status ScrollY" style="cursor: pointer; font-size: 14px;">
              <p><a (click)="getDeepDivebyStatus1($event, true)" [ngClass]="{active : Isselected1 }"
                  style="font-size: 14px;">ALL</a></p>
              <p><a (click)="getDeepDivebyStatus2($event, true)" [ngClass]="{active : Isselected2 }"
                  style="font-size: 14px;">Completed</a></p>
              <p><a (click)="getDeepDivebyStatus3($event, true)" [ngClass]="{active : Isselected3 }"
                  style="font-size: 14px;">Failed</a></p>
              <p><a (click)="getDeepDivebyStatus4($event, true)" [ngClass]="{active : Isselected4 }"
                  style="font-size: 14px;">Reclassification Failed</a></p>
              <p><a (click)="getDeepDivebyStatus5($event, true)" [ngClass]="{active : Isselected5 }"
                  style="font-size: 14px;">In Progress</a></p>
              <p><a (click)="getDeepDivebyStatus6($event, true)" [ngClass]="{active : Isselected6 }"
                  style="font-size: 14px;">Insufficient Tickets</a></p>
              <p><a (click)="getDeepDivebyStatus7($event, true)" [ngClass]="{active : Isselected7 }"
                  style="font-size: 14px;">No Opportunities Found</a></p>
              <p><a (click)="getDeepDivebyStatus8($event, true)" [ngClass]="{active : Isselected8 }"
                  style="font-size: 14px;">No Tickets</a></p>
              <p><a (click)="getDeepDivebyStatus9($event, true)" [ngClass]="{active : Isselected9 }"
                  style="font-size: 14px;">Reupload</a></p>
              <!-- <p *ngFor="let ddStatus in DistinctStatusList"><a (click)="getDeepDivebyStatus5($event)" [ngClass]="{active : Isselected5 }"
                    style="font-size: 14px;">{{ddStatus}}</a></p> -->
            </div>
          </div>
          <!-- <div class="col-auto">
            <div class="form-group">
              <select class="form-control control-border" style="cursor: pointer;"
                (change)="getDeepDivebyStatus($event)" [(ngModel)]="selectedStatus">
                <option value="All" selected>All</option>
                <option value="Completed">Completed</option>
                <option value="In Progress">In Progress</option>
                <option value="Failed">Failed</option>
                <option value="Reclassification Failed">Reclassification Failed</option>
              </select>
            </div>
          </div> -->
        </div>
        <div class="dropdown iom-drop-body d-flex" [ngClass]="{'disabled': isDisabled == true || ddExport == false}">
          <a href="javascript:;" class="myw-login iom-drop-item dropdown-toggle iombtn-icon mr-2"
            (click)="showDisclaimerpopup()" title="Export"><img src="assets/images/export-icon.svg" alt=""
              class="myw-icon mr-2">Export</a>
        </div>
        <div *ngIf="ddFilter" (clickOutside)="onClickedOutsideFilter($event)"
          class="dropdown dropright dropflat d-flex filterdd" [ngClass]="{'show':displayFilter && !disfilter}">
          <a href="javascript:;" class="iombtn-icon mr-2 myw-navbar-action" (click)="displayFilterToggle()"
            data-bs-display="static" aria-haspopup="true" aria-expanded="false" id="selectPhase"><img
              src="assets/images/filter-icon.svg" alt="" class="myw-icon mr-2">Filter</a>
          <div *ngIf="lstFilterResponse.length > 0" [ngClass]="{'show':displayFilter && !disfilter}"
            class="dropdown-menu dropdown-xl" #filterPopup aria-labelledby="selectPhase">
            <div class="iom-filter p-3">
              <div class="d-flex align-items-center">
                <h6 class="dropdown-title">Filter</h6>
              </div>
              <div class="dropdown-body">
                <div *ngIf="loadoldFilter" class="row">
                  <div class="col-6" *ngFor="let t of lstFilterResponse">
                    <div class="form-group">
                      <label class="form-label"><b>{{t.DimensionName}}</b></label>
                      <div>
                        <ng-multiselect-dropdown class="drp-filter" [placeholder]="'Select'" [(ngModel)]="t.SelectDim"
                          [data]="t.DimensionValues" [disabled]="disabled" [settings]="dropdownSettings"
                          (enableCheckAll)="false" (onSelect)="onItemSelect(t.DimensionName,$event.DimensionValue)"
                          (onSelectAll)="onSelectAll(t.DimensionName,$event)"
                          (onDeSelect)="onItemDeSelect(t.DimensionName,$event.DimensionValue)"
                          (onDeSelectAll)="onItemDeSelectAll(t.DimensionName,$event)">
                        </ng-multiselect-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center mt-3">
                  <button type="reset" class="btn btn-secondary" (click)="clearAllFilters()">Clear All</button>
                  <button type="reset" class="btn btn-secondary ml-auto mr-3"
                    (click)="cancelFilterPopup()">Cancel</button>
                  <button type="button" class="btn btn-primary" (click)="applySelectedFilteredValues()">Apply</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="envData.Env == 'FDS_ManualUpload' || envData.Env == 'SAAS_ManualUpload'"  class="mr-2">
          <a class="btn btn-secondary fs-12 align-self-center" 
            (click)="NavigateAutomationPlanner()" [ngClass]="{'disabled':  isDisabled == true || dqtAutomate == false }">Automate</a>
        </div>
      </div>
    </div>

    <!-- <div class="myw-navbar">
    <div class="myw-inner myw-container align-items-center d-flex flex-wrap">
      
      <a href="javascript:;" [routerLink]="['/Ticket/AutomationMitigation']"
        [queryParams]="{'VersionId': VersionId, 'DDName': DDName}" style="cursor: pointer;"
        class="btn nav-btn iom-svg-icon">
        <img src="assets/images/filter.svg" alt="Review &amp; Automation Opportunities">
        <span class="text-nowrap">Review Automation Opportunities</span>
      </a>
      <a href="javascript:;" class="btn nav-btn iom-svg-icon">
        <img src="assets/images/trend-analysis.svg" alt="Trend Analysis">
        <span class="text-nowrap">Trend Analysis</span>
      </a>
      <a href="javascript:;" (click)="exportDeepdive(VersionId,DDName)" style="cursor: pointer;"
        class="btn nav-btn iom-svg-icon">
        <img src="assets/images/text-analysis.svg" alt="Text Analysis">
        <span class="text-nowrap">Text Analysis</span>
      </a>
      <a href="javascript:;" class="btn nav-btn iom-svg-icon">
        <img src="assets/images/export.svg" alt="Export">
        <span class="text-nowrap">Export</span>
      </a>
      <a href="javascript:;" (click)="NavigateAutomationPlanner()" style="cursor: pointer;"
        class="ml-auto btn btn-secondary iom-svg-icon">
        <img src="assets/images/automate.svg" alt="Automate" class="btn-img">
        <span>Automate</span>
      </a>

    </div>
  </div> -->
    <!-- /navbar -->
    <!-- <div class="d-flex pt-4 pb-4">
      <h1 class="fs-20">Deepdive Summary</h1>
      <div class="align-self-center ml-auto fs-12"><a href="javascript:;" (click)="navigateToCreatedeepdive()"
          class="btn btn-primary fs-12">Create
          New Deepdive</a></div>
    </div> -->


    <div class="position-relative mb-4">
      <div class="row myw-grid">
        <div class="col-3 ">
          <!--left bar-->
          <div class="iom-side-menu-section">
            <div>
              <div *ngIf="this.iomservice.readonlyDD == false && ((this.envData.Env == 'FDS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '3') || (this.envData.Env == 'SAAS_ManualUpload'))"
                style="cursor: pointer;" class="d-flex iom-deep-newcre align-items-center justify-content-center"
                (click)="navigateToCreatedeepdive()">
                <a style="cursor: pointer;">
                  <img src="assets/images/create-plus.svg" alt="Create New Category" class="btn-img myw-icon myw-24">
                  <span>Create New Deepdive</span>
                </a>
              </div>
              <div *ngIf="this.iomservice.readonlyDD == true" style="cursor: pointer;opacity: .5;"
                class="d-flex iom-deep-newcre align-items-center justify-content-center disabled"
                (click)="navigateToCreatedeepdive()">
                <a style="cursor: pointer;">
                  <img src="assets/images/create-plus.svg" alt="Create New Category" class="btn-img myw-icon myw-24">
                  <span>Create New Deepdive</span>
                </a>
              </div>
              <div *ngIf="this.iomservice.readonlyDD == false && ((this.envData.Env == 'FDS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '1'))"
                style="cursor: pointer;" class="d-flex iom-deep-newcre align-items-center justify-content-center"
                (click)="manualUpload()" id="manualUpload">
                <a style="cursor: pointer;">
                  <img src="assets/images/create-plus.svg" alt="Create New Category" class="btn-img myw-icon myw-24">
                  <span>Create New Deepdive</span>
                </a>
              </div>
              <div class="iom-side-menu-section1 iom-left-scroll">
                <div class="iom-list ScrollDDY">
                  <div class="d-flex flex-column" *ngFor="let child of DeepDiveDataFiltered"
                    (click)="ddtiles($event,child)" id="iomTile_{{child.VersionIdMongo}}">
                    <a href="javascript:;" style="cursor: pointer;" title={{child.VersionIdMongo}}
                      [ngClass]="{'tileActive': child.VersionIdMongo == VersionIdMongo,'iom-list-item deepdive1':true}">
                      <div class="d-flex mb-3 align-items-center">
                        <h3 class="fs-16 mb-0 myw-700 ddNameEllipsis" title="{{child.DDName}}">{{child.DDName}}</h3>
                        <a href="javascript:;" title="Refresh" *ngIf="((this.envData.Env == 'FDS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '3') || (this.envData.Env == 'SAAS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '1')) && (child.VersionIdMongo == VersionIdMongo && child.Status.indexOf('Inprogress') == -1 && child.IsDisableEditCatgoryandSubcategory != 1)"  class="ml-auto mx-2 iom-refresh-icon" (click)="RefreshFDSDeepdive(child)">
                          <img src="assets/images/Icon refresh - white.svg" class="myw-icon myw-14" alt="Refresh"/>
                        </a>
                        <a href="javascript:;" title="Refresh" *ngIf="((this.envData.Env == 'FDS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '3') || (this.envData.Env == 'SAAS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '1')) && (child.VersionIdMongo != VersionIdMongo && child.Status.indexOf('Inprogress') == -1  && child.IsDisableEditCatgoryandSubcategory != 1)"  class="ml-auto mx-2 iom-refresh-icon" (click)="RefreshFDSDeepdive(child)">
                          <img src="assets/images/Icon -refresh - grey.svg" class="myw-icon myw-14" alt="Refresh"/>
                        </a>
                        <img src="assets/images/Icon refresh - white.svg" title="Reupload" *ngIf="((this.envData.Env == 'FDS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '1') || (this.envData.Env == 'SAAS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '3')) && (child.VersionIdMongo == VersionIdMongo && child.Status.indexOf('Inprogress') == -1  && child.IsDisableEditCatgoryandSubcategory != 1)"
                             class="ml-auto mx-2 iom-refresh-icon myw-icon myw-14" (click)="ReUploadFile(child)" alt="Refresh" style="cursor: pointer;"/>
                        <img src="assets/images/Icon -refresh - grey.svg" title="Reupload" *ngIf="((this.envData.Env == 'FDS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '1') || (this.envData.Env == 'SAAS_ManualUpload' && this.sessionservice.getSessionStorageItem('userType') == '3')) && (child.VersionIdMongo != VersionIdMongo && child.Status.indexOf('Inprogress') == -1  && child.IsDisableEditCatgoryandSubcategory != 1)"
                             class="ml-auto mx-2 iom-refresh-icon myw-icon myw-14" (click)="ReUploadFile(child)" alt="Refresh" style="cursor: pointer;"/>
                        <img src="assets/images/hide-white.svg" *ngIf="child.ShowHide == true && child.VersionIdMongo == VersionIdMongo && child.Status.indexOf('Inprogress') == -1" alt="view"
                             (click)="hideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                        <img src="assets/images/hide-white.svg" *ngIf="child.ShowHide == true && child.VersionIdMongo == VersionIdMongo && child.Status.indexOf('Inprogress') != -1" alt="view"
                             (click)="hideDeepDive(child)" class="ml-auto myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                        <img src="assets/images/hide.svg" *ngIf="child.ShowHide == true && child.VersionIdMongo != VersionIdMongo && !InactiveDD && child.Status.indexOf('Inprogress') == -1"
                             alt="view" (click)="hideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                        <img src="assets/images/hide.svg" *ngIf="child.ShowHide == true && child.VersionIdMongo != VersionIdMongo && !InactiveDD && child.Status.indexOf('Inprogress') != -1"
                             alt="view" (click)="hideDeepDive(child)" class="ml-auto myw-icon myw-18  eye-icon-margin"style="cursor: pointer;">

                        <img src="assets/images/hide.svg" *ngIf='child.ShowHide == false && !InactiveDD' alt="view"
                             (click)="UnhideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin"
                             style="cursor: pointer;">
                        <img src="assets/images/eye.svg" *ngIf="child.VersionIdMongo != VersionIdMongo && InactiveDD && child.Status.indexOf('Inprogress') == -1"
                             alt="view" (click)="UnhideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                        <img src="assets/images/eye.svg" *ngIf="child.VersionIdMongo != VersionIdMongo && InactiveDD && child.Status.indexOf('Inprogress') != -1"
                             alt="view" (click)="UnhideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                        <img src="assets/images/eye-white.svg" *ngIf="child.VersionIdMongo == VersionIdMongo && InactiveDD && child.Status.indexOf('Inprogress') == -1" alt="view"
                             (click)="UnhideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                        <img src="assets/images/eye-white.svg" *ngIf="child.VersionIdMongo == VersionIdMongo && InactiveDD && child.Status.indexOf('Inprogress') != -1" alt="view"
                             (click)="UnhideDeepDive(child)" class="myw-icon myw-18  eye-icon-margin" style="cursor: pointer;">
                      </div>
                      <p *ngIf="envData.EnableLanguage" [ngClass]="{'disabled': isDisabled == true}">Ticket Language -
                        <span>{{child.Language}}</span></p>
                      <p>No of Categories - <span>{{child.TotalCategory}}</span></p>
                      <p>No of classified Tickets -
                        <strong>{{formatNumber(child.CategorisedTicketcount)}}</strong><strong>/</strong><strong>{{formatNumber(child.TotalTicketCount)}}</strong>
                      </p>
                      <!-- <p class="d-flex flex-wrap align-items-center">
                        <span class="mr-3">{{child.ModifiedOn}}</span>
                        <span class="mr-auto d-flex align-items-center"
                          [ngClass]="{'iom-completed': child.Status === 'Completed','iom-failed': child.Status === 'Failed'}">{{child.Status}}
                          <img *ngIf="child.Status == 'Completed'" src="assets/images/check-icon.svg" alt="Completed"
                            class="myw-icon ml-1 myw-12">
                          <img *ngIf="child.Status == 'Failed'" src="assets/images/close-icon.svg" alt="Failed"
                            class="myw-icon ml-1 myw-10"></span>
                      </p> -->
                      <div class="myw-file-item d-flex">
                        <div class="flex-fill">
                          <div class="form-row">
                            <div class="col-auto">
                              <h6>{{child.ModifiedOn}}</h6>
                            </div>
                            <div class="col">
                            <div [ngClass]="{'iom-completed': child.DQTStatus === 'Completed'
                              && child.DQTStatus != 'DQT Failed' && child.DQTStatus != 'No Tickets' && child.DQTStatus != 'Insufficient tickets'
                              && child.DQTStatus.split(' ')[0].trim() != '3%','iom-failed': child.DQTStatus == 'DQT Failed'}">
                                <img *ngIf=" child.DQTStatus == 'Completed' &&
                              child.DQTStatus != 'DQT Failed' &&  child.DQTStatus != 'No Tickets' && child.DQTStatus != 'Insufficient tickets'
                             && child.DQTStatus.split(' ')[0].trim() != '3%'" src="assets/images/check-icon.svg"
                                     alt="Completed" class="myw-icon mr-1 myw-12 ">
                                <img *ngIf="child.DQTStatus == 'DQT Failed' &&
                               child.DQTStatus != 'Completed' && child.DQTStatus != 'No Tickets' && child.DQTStatus != 'Insufficient tickets'
                              && child.DQTStatus.split(' ')[0].trim() != '3%' && child.DQTStatus.split(' ')[0].trim() != '0%'"
                                     src="assets/images/close-icon.svg" alt="Failed" class="myw-icon mr-1 myw-10">
                                <div *ngIf="child.DQTStatus != 'Completed'
                                  && child.DQTStatus.split(' ')[0].trim() != '0%' && child.DQTStatus != 'DQT Failed' && child.DQTStatus != 'No Tickets'"
                                     class="progress">
                                  <div *ngIf="child.DQTStatus != 'Completed'
                                    && child.DQTStatus.split(' ')[0].trim() != '0%' && child.DQTStatus != 'DQT Failed' && child.DQTStatus != 'No Tickets'"
                                       class="progress-bar" role="progressbar" aria-valuenow="40" aria-valuemin="0"
                                       aria-valuemax="100" [style.width]='child.DQTProgressStatus'>
                                  </div>
                                </div>
                                <!--<small *ngIf ="child.DQTStatus != 'Completed' && child.Status != 'Completed'" [ngClass]="{'iom-completed': child.Status === 'Completed' || child.Status === 'No Opportunities Found' && child.DQTStatus === 'Completed','iom-failed': child.Status === 'Failed'}">DQT {{child.DQTStatus}}</small> -->
                                <small *ngIf="child.DQTStatus == 'DQT Failed'" [ngClass]="">
                                  {{child.DQTStatus}}
                                </small>
                                <small *ngIf="child.DQTStatus == 'Completed'" [ngClass]="">
                                  DQT {{child.DQTStatus}}
                                </small>
                                <small *ngIf="child.DQTStatus != 'Completed' && child.EnableDQT == 1  && child.DQTStatus != 'DQT Failed' " [ngClass]="">
                                  DQT {{child.DQTStatus}}
                                </small>
                              </div>
                              <div [ngClass]="{'iom-completed': child.Status === 'Completed' || child.Status === 'No Opportunities Found'
                              && child.Status != 'Failed' && child.Status != 'Reclassification Failed' && child.Status != 'No Tickets' && child.Status != 'Reupload' && child.Status != 'Insufficient tickets'
                              && child.Status.split(' ')[0].trim() != '3%','iom-failed': child.Status === 'Failed'}">
                                <img *ngIf="child.Status == 'Completed' && child.Status != 'No Opportunities Found' &&
                              child.Status != 'Failed' && child.Status != 'Reclassification Failed' && child.Status != 'No Tickets' && child.Status != 'Reupload' && child.Status != 'Insufficient tickets'
                             && child.Status.split(' ')[0].trim() != '3%'" src="assets/images/check-icon.svg"
                                  alt="Completed" class="myw-icon mr-1 myw-12 ">
                                <img
                                  *ngIf="child.Status == 'Failed' && child.Status != 'No Opportunities Found' &&
                              child.Status != 'Reclassification Failed' && child.Status != 'No Tickets' && child.Status != 'Reupload' && child.Status != 'Insufficient tickets'
                              && child.Status.split(' ')[0].trim() != '3%'"
                                  src="assets/images/close-icon.svg" alt="Failed" class="myw-icon mr-1 myw-10">
                                <div
                                  *ngIf="child.Status != 'Completed' && child.Status != 'No Opportunities Found' && child.Status != 'Failed' && child.Status != 'Reclassification Failed' && child.Status != 'No Tickets' && child.Status != 'Reupload' && child.Status != 'Insufficient tickets' && child.DDProgressStatus != undefined" 
                                  class="progress">
                                  <div
                                    *ngIf="child.Status != 'Completed' && child.Status != 'No Opportunities Found' && child.Status != 'Failed' && child.Status != 'Reclassification Failed' && child.Status != 'No Tickets' && child.Status != 'Reupload' && child.Status != 'Insufficient tickets' && child.DDProgressStatus != undefined" 
                                    class="progress-bar" role="progressbar" aria-valuenow="40" aria-valuemin="0"
                                    aria-valuemax="100" [style.width]='child.DDProgressStatus'>
                                  </div>
                                </div>
                                <small *ngIf="child.Status == 'Completed' || child.Status == 'No Opportunities Found' || child.Status == 'Failed' || child.Status =='Reclassification Failed' || child.Status =='No Tickets' || child.Status == 'Reupload' || child.Status == 'Insufficient tickets' || (child.Status.split(' ')[2] == 'Reclassification' || child.Status.split(' ')[2] == 'Inprogress' && child.DDProgressStatus != undefined)" [ngClass]="">
                                  Deepdive {{child.Status}}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="accordion" class="accordion"
                        *ngIf="dqtStatus == false && (VersionIdMongo === child.VersionIdMongo) ? true : false">
                        <div class="iom-view-details position-relative" [ngClass]="{'disabled':newstatus1==true}">
                          <div class="view-header readmorebtn"
                            [ngClass]="{'collapsed':!(child.VersionIdMongo === expandDD)}" data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#ver_' + child.VersionIdMongo" aria-expanded="true"
                            aria-controls="category1">
                            <a class="card-title hideViewDetails" style="cursor: pointer;">View Details</a>
                          </div>
                        </div>
                      </div>
                    </a>
                    <div id="ver_{{child.VersionIdMongo}}" class="view-body collapse"
                      [ngClass]="{'show':(child.VersionIdMongo === expandDD)}"
                      *ngIf="dqtStatus == false && (VersionIdMongo === child.VersionIdMongo) ? true : false">
                      <div class="iom-tree-body">
                        <div class="accordion iom-list-accordian" id="iomtrend">
                          <div class="iom-card-lst" *ngFor="let category of CatSubcatData | ticketcountfilter:true">
                            <div class="iom-card-header" id="authhead">
                              <a href="javascript:;" [ngClass]="{ 'active' : ActiveCat === category.CategoryId }"
                                (click)="LoadTrendOrTextAnalysis(category.CategoryId, category.CategoryName, null, category.TicketCount)"
                                class="subCatCls iom-accordian-item iom-auth fs-13 text-col" data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#cat_' + category.CategoryId"
                                aria-controls="devlopmentcollapse">{{
                                category.CategoryName }}({{category.Percentage}}%) </a>
                            </div>
                            <div id="cat_{{category.CategoryId}}" class="collapse show" data-bs-parent="#iomtrend"
                              *ngFor="let subCat of category.SubCategoryDetails | ticketcountfilter:false">
                              <div class="imo-card-body">
                                <div class="iom-accordian-tree">
                                  <a class="subCatCls fs-13 text-col" href="javascript:;"
                                    [ngClass]="{ 'active' : ActiveSubcat === subCat.SubCategoryID }"
                                    (click)="LoadTrendOrTextAnalysis(subCat.CatgoryID, subCat.SubCategoryName, subCat.SubCategoryID, subCat.Sub_TicketCount)">
                                    {{ subCat.SubCategoryName }}({{subCat.Sub_Percentage}}%)</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="dd-noactive col-9" *ngIf='ddDataLength == 0 '>
          <div class="card iom-card">
            <div class="card-body my-5">
              <h4 class="card-title text-center text-white">{{activeinactiveddtext}}</h4>
            </div>
          </div>
        </div>
        <div class="dd-noactive col-9" *ngIf='newstatus == true && dqtStatus == false'>
          <div class="card iom-card">
            <div class="card-body my-5">
              <h4 class="card-title text-center text-white">{{activeinactiveddtext}}</h4>
            </div>
          </div>
        </div>
        <div class="dd-noactive col-9" *ngIf='newstatus1 == true'>
          <div class="iom-secnavbar">
            <div class="align-items-center d-flex flex-wrap">
              <a class="secnav-btn active" (click)="loadDeepdive()" [ngClass]="{active: isLoadDeepdive }"
                style="cursor: pointer;">
                <span class="text-nowrap">Deepdive Summary</span>
              </a>
              <a class="secnav-btn" (click)="loadReview()" [ngClass]="{active: isLoadReview }" style="cursor: pointer;">
                <span class="text-nowrap">Review Automation Opportunities</span>
              </a>
              <a class="secnav-btn" (click)="loadTrend()" [ngClass]="{active: isLoadTrend }" style="cursor: pointer;">
                <span class="text-nowrap">Trend Analysis</span>
              </a>
              <a class="secnav-btn" (click)="loadText()" [ngClass]="{active: isLoadText }" style="cursor: pointer;">
                <span class="text-nowrap">Text Analysis</span>
              </a>
              <a *ngIf="enableDQT" class="secnav-btn" (click)="loadDQT()" [ngClass]="{active: isLoadDQT }" style="cursor: pointer;">
                <span class="text-nowrap">Data Quality</span>
              </a>
            </div>
          </div>
          <div class="card iom-card" *ngIf="dqtStatus == false">
            <div class="card-body my-5">
              <h4 class="card-title text-center text-white">{{activeinactiveddtext}}</h4>
            </div>
          </div>
        </div>
        <!-- <div *ngIf='ddDataLength == 0' class="col-9 my-4 text-center">
          <h4 style="margin-right: 14.08rem;">{{activeinactiveddtext}}</h4>
        </div> -->
        <div *ngIf="showcharts == true  &&  dqtStatus == true" class="col-9">
          <div class="iom-secnavbar">
            <div class="align-items-center d-flex flex-wrap">
              <a class="secnav-btn" style="cursor: pointer;" (click)="loadDQT()">
                <span class="text-nowrap">Data Quality</span>
              </a>
              <app-data-quality-assessment [magicNumber]="magicNumber" *ngIf="isLoadDQT" [isProceed]="isProceed">
              </app-data-quality-assessment>
            </div>
          </div>
        </div>
        <div
          *ngIf="showcharts == false && deepDivestatus != null && deepDivestatus != ' ' && deepDivestatus != 'Insufficient' && deepDivestatus != 'Failed' && deepDivestatus != 'No Opportunities Found' && deepDivestatus != 'No Tickets' && deepDivestatus != '3%'"
          class="col-9">
          <div class="progressheight">
            <div class="align-items-center d-flex flex-wrap progressheight">
              <div class="progressstrip posistion-relative progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated active" role="progressbar"
                  aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" [style.width]='deepDivestatus'>
                  {{deepDivestatus}}<span class="d-flex align-items-center justify-content-center iom-inprogress">In
                    progress</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="ddDataLength != 0 && showcharts == true && newstatus1 == false  && dqtStatus == false"
          class="col-9">
          <div class="iom-secnavbar">
            <div class="align-items-center d-flex flex-wrap">
              <a class="secnav-btn active" (click)="loadDeepdive()" [ngClass]="{active: isLoadDeepdive }"
                style="cursor: pointer;">
                <span class="text-nowrap">Deepdive Summary</span>
              </a>
              <a class="secnav-btn" (click)="loadReview()" [ngClass]="{active: isLoadReview }" style="cursor: pointer;">
                <span class="text-nowrap">Review Automation Opportunities</span>
              </a>
              <a class="secnav-btn" (click)="loadTrend()" [ngClass]="{active: isLoadTrend }" style="cursor: pointer;">
                <!--<a [routerLink]="['/Ticket/TicketCategoryDetails']"
                [queryParams]="{'VersionId': VersionId, 'DDName' : DDName}" class="secnav-btn" (click)="loadTrend()"
                [ngClass]="{active: isLoadTrend }">-->
                <span class="text-nowrap">Trend Analysis</span>
              </a>
              <a class="secnav-btn" (click)="loadText()" [ngClass]="{active: isLoadText }" style="cursor: pointer;">
                <span class="text-nowrap">Text Analysis</span>
              </a>
              <a *ngIf="enableDQT" class="secnav-btn" (click)="loadDQT()" [ngClass]="{active: isLoadDQT }" style="cursor: pointer;">
                <span class="text-nowrap">Data Quality</span>
              </a>
            </div>
          </div>
          <!--Deepdive screen-->
          <div *ngIf="isLoadDeepdive">
			<div class="row myw-grid">
				<div class="col-12">
					<div class="card iom-card">
						<div class="card-header">
							<h4 class="card-title pt-2">Deepdive Details</h4>
						</div>
						<div class="card-body">
							<div class="form-row">
								<div class="col-6 col-lg-4">
									<div class="form-group form-inline">
										<label class="form-label-txt">Ticket Start Date : </label>
										<span class="ml-1">{{this.DDStartDate}}</span>
									</div>
								</div>
								<div class="col-6 col-lg-4">
									<div class="form-group form-inline">
										<label class="form-label-txt">Ticket End Date : </label>
										<span class="ml-1">{{this.DDEndDate}}</span>
									</div>
								</div>
								<div class="col-6 col-lg-4">
									<div class="form-group form-inline">
										<label class="form-label-txt">Classified Based On :</label>
										<span class="ml-1">{{this.DDClassificationBasedOn}}</span>
									</div>
								</div>
								<div class="col-6 col-lg-4">
									<div class="form-group form-inline">
										<label class="form-label-txt">Algorithm Model :</label>
										<span class="ml-1">{{this.DDAlgorithm}}</span>
									</div>
								</div>
								<div class="col-6 col-lg-4" *ngIf="showDDTicketType">
									<div class="form-group form-inline">
										<label class="form-label-txt">Ticket Type :</label>
										<span class="ml-1">{{DDTicketType}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div class="row myw-grid">
              <div *ngIf="loadDoughnut" class="col-12 col-lg-6 d-flex">
                <div class="card iom-card minheight">
                  <div class="card-header flex-wrap">
                    <h4 class="card-title">Total Tickets</h4>
                  </div>
                  <div class="card-body">
                    <div id="deepDonughtchart">
                      <app-donut [TotalTicketcount]="TotalTicketCountLabel"
                        [CategorisedTicketcount]="CategorisedTicketcount"></app-donut>
                    </div>
                    <div class="d-flex ml-auto align-items-center justify-content-end flex-wrap">
                      <span class="iom-legend cr-1"></span><span class="fs-10">Classified(Repeat)</span>
                      <span class="iom-legend ml-3" style="background-color:#6808D8"></span><span class="fs-10">Non
                        Classified(Non Repeat)</span>
                    </div>
                  </div>
                  <div *ngIf="!isdataAvailable" class="card-header">
                    <h4 class="card-title pt-2">Top 10 Opportunities</h4>
                  </div>
                  <div *ngIf="!isdataAvailable" class="card-body">
                    <div class="align-items-center justify-content-center" id="treemapSummary">
                      <app-treemapsummary-chart [GraphData]="CatSubcatData" [chartContainer]="treemapSummary"
                        [isExpand]="false"></app-treemapsummary-chart>
                    </div>
                    <div *ngIf="displayExpandTreeMap" class="d-flex justify-content-end fs-12 myw-500">
                      <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#tabularModal"
                        style="margin-right: 18rem;">Tabular View</a>
                      <a *ngIf="displayExpandTreeMap" href="javascript:;" (click)="ExpandTreemap = true;"
                        data-bs-toggle="modal" data-bs-target="#expandModal">Expand</a>
                    </div>
                  </div>
                  <div class="iom-dotted"></div>
                </div>
              </div>
              <!-- <div class="col-12 col-lg-6 d-flex">
                <div class="card iom-card minheight">
                  <div class="card-header">
                    <h4 class="card-title pt-2">Identified Opportunities</h4>
                  </div>
                  <div class="card-body contentHolder ps ps--active-x ps--active-y">
                    <div class="align-items-center justify-content-center">
                      <app-weightage-chart [GraphData]="CatSubcatData"></app-weightage-chart>
                    </div>
                  </div>
                </div>
              </div> -->
              <div *ngIf="CatSubcatData != null" class="col-12 col-lg-6 d-flex">
                <div class="card iom-card minheight">
                  <div class="card-header">
                    <h4 class="card-title pt-2">Identified Opportunities</h4>
                  </div>
                  <div class="card-body contentHolder ps ps--active-x ps--active-y">
                    <div class="align-items-center justify-content-center">
                      <app-weightage-chart [GraphData]="CatSubcatData"></app-weightage-chart>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="NoDataCat == true && NoDataKey == true"
                style="margin-left: 19rem;font-size: 15px;font-weight: bold;padding-top: 25px;">
                No data available for selected filter.
              </div>
            </div>
            <h4 *ngIf="keyChartGraphData" class="fs-16 mb-3 ml-1">Key Insights</h4>
            <div *ngIf="keyChartGraphData" class="row myw-grid">
              <div class="col-12 col-lg-6 d-flex" *ngFor="let item of keyChartGraphData | keyvalue">
                <div class="card iom-card">
                  <div class="card-header">
                    <h4 class="card-title">{{GetChartTitle(item.key)}}</h4><span class="rowranking"
                      style="display:none;">{{GetRowRank(item.key, true)}}</span>
                  </div>
                  <div style="padding-left: 1rem;" id="keymsg_{{GetRowRank(item.key, true)}}"></div>
                  <div class="card-body" id="container_{{GetRowRank(item.key, true)}}">
                    <div class="imo-card-chat">
                      <app-d3-chart [Data]="item.value" [IsOverAll]="true" [Rowrank]="GetRowRank(item.key, true)"
                        [IsEdit]="false">
                      </app-d3-chart>
                    </div>
                  </div>
                  <div style="margin-right: 2rem; margin-bottom: 1rem" *ngIf="GetRowRank(item.key, true) == 10005"
                    class="d-flex justify-content-end fs-12 myw-500">
                    <a id="expend_keychart" href="javascript:;" data-bs-toggle="modal"
                      data-bs-target="#paretoExpandModal" (click)="changeSeletion()">Expand</a>
                  </div>
                </div>
              </div>
            </div>
            <!--Authorization Issues -->
            <div class="row myw-grid">
              <div *ngIf="CatSubcatData" class="col">
                <div *ngFor="let item of CatSubcatData" class="card iom-card imo-card-edit">
                  <div class="card-header">
                    <h4 id="categorylink_{{item.CategoryId}}" style="cursor: pointer;"
                      (mouseover)="over(item.CategoryId)" (mouseout)="out(item.CategoryId)"
                      (click)="redirectToAutomation(item.CategoryId);" class="card-title">{{item.CategoryName}}</h4>
                    <span style="width: 30rem;"></span>
                    <a href="javascript:;" class="btn btn-icon" title="Show Details" style="cursor: pointer;"
                      (click)="LoadTrendOrTextAnalysis(item.CategoryId, item.CategoryName, null, item.TicketCount)">
                      <img src="assets/images/expand.svg" alt="Expand" class="myw-icon myw-16">
                      <span class="sr-only">Expand</span>
                    </a>
                  </div>
                  <div class="row px-3 pb-4 h-100">
                    <div class="col-12 col-lg-5 iom-bdr-dashed">
                      <div class="row align-items-center">
                        <div class="col-auto pr-0">
                          <div class="iom-piedgram">
                            <svg width="100%" height="100%" viewBox="0 0 42 42">
                              <circle r="15.91549430918954" cx="21" cy="21" fill="transparent" stroke="#edecfe"
                                stroke-width="3"></circle>
                              <circle r="15.91549430918954" cx="21" cy="21" fill="transparent" stroke="#a2a1fb"
                                stroke-width="3"
                                [attr.stroke-dasharray]="item.Percentage + ' ' + (100 - item.Percentage)"
                                stroke-dashoffset="25"></circle>
                            </svg>
                            <p><strong>{{item.Percentage}}%</strong><br /><span class="fs-10">
                                {{item.TicketCount}} Tickets</span></p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex justify-content-end">
                            <div class="iom-navbar-tab imo-deepdive justify-content-end ">
                              <a *ngIf="this.iomservice.readonlyDD == false" href="javascript:;"
                                class="btn btn-icon imo-border" (click)="EditObservation(item.CategoryId)" title="Edit"
                                style="cursor: pointer;">
                                <img src="assets/images/edit.svg" id="editicon_{{item.CategoryId}}" alt="Edit"
                                  class="myw-icon myw-12">
                                <span class="sr-only">Edit</span>
                              </a>
                              <a *ngIf="this.iomservice.readonlyDD == true" href="javascript:;"
                                class="btn btn-icon imo-border disabled" (click)="EditObservation(item.CategoryId)"
                                title="Edit">
                                <img src="assets/images/edit.svg" id="editicon_{{item.CategoryId}}" alt="Edit"
                                  class="myw-icon myw-12">
                                <span class="sr-only">Edit</span>
                              </a>
                              <a href="javascript:;" class="btn btn-icon" (click)="ResetObservation(item.CategoryId)"
                                title="Refresh" style="cursor: pointer;">
                                <img src="assets/images/refresh.svg" alt="Refresh" class="myw-icon myw-12">
                                <span class="sr-only">Refresh</span>
                              </a>
                            </div>
                          </div>
                          <div class="d-flex fs-12 ScrollY pad-1" contenteditable="false"
                            id="editobserv_{{item.CategoryId}}" style="overflow: auto;height: 93px;">
                            {{item.Observation}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 iom-bdr-dashed">
                      <div class="align-items-center justify-content-center">
                        <div id="mlabelpie{{item.CategoryId}}">
                          <app-multilevel-piechart [GraphData]="CatSubcatData" [categoryId]="item.CategoryId">
                          </app-multilevel-piechart>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="align-items-center justify-content-center">
                        <div id="trend{{item.CategoryId}}">
                          <app-trend-chart [GraphData]="CatSubcatData" [categoryId]="item.CategoryId"></app-trend-chart>
                        </div>
                        <div class="align-items-center justify-content-center flex-column">
                          <div class="mb-4" id="trend{{item.CategoryId}}">
                            <app-trend-chart [GraphData]="CatSubcatData" [categoryId]="item.CategoryId">
                            </app-trend-chart>
                          </div>
                          <div class="iom-graph-det d-flex align-items-center justify-content-center">
                            <div class="iom-gpdet-lft">
                              <img data-bs-previouspage="0" class="trendLeft" id="trend_left_{{item.CategoryId}}"
                                src="assets/images/imo-deep-arrow.svg" alt="">
                            </div>
                            <div class="iom-gpdet-mid">Ticket Trend - <span id="trendTitle_{{item.CategoryId}}"></span>
                            </div>
                            <div class="iom-gpdet-rgt"><img data-bs-nextpage="0" class="trendRight"
                                id="trend_right_{{item.CategoryId}}" src="assets/images/imo-deep-arrow.svg" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Review automation-->
          <app-automation-opportunities [magicNumber]="magicNumber" [DQTFilterDetails]="DQTFilterDetails"
            [IsFilterModified]="IsFilterModified" *ngIf="isLoadReview"></app-automation-opportunities>
          <!--Trend Analysis-->
          <app-trend-analysis [magicNumber]="magicNumber" *ngIf="isLoadTrend"
            [TextcategoryOrSubcategoryName]="TextcategoryOrSubcategoryName" [TextTicketCount]="TextTicketCount">
          </app-trend-analysis>
          <!--Text Analysis-->
          <app-text-analysis [magicNumber]="magicNumber" *ngIf="isLoadText"
            [TextcategoryOrSubcategoryName]="TextcategoryOrSubcategoryName" [wordreset]="wordreset"
            [TextTicketCount]="TextTicketCount">
          </app-text-analysis>
          <!--Data Quality Assessment-->
          <app-data-quality-assessment [magicNumber]="magicNumber" *ngIf="isLoadDQT" [isProceed]="isProceed">
          </app-data-quality-assessment>
        </div>
      </div>
    </div>
    <div class="modal" id="expandModal" tabindex="-1" role="dialog" aria-labelledby="expandTit" aria-hidden="true"
      data-bs-backdrop="static">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content iom-modewhite">
          <div class="modal-header">
            <h5 class="modal-title" id="expandTit">Identified Opportunities</h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <app-expandtree-chart [GraphData]="CatSubcatData"></app-expandtree-chart> -->
            <div class="justify-content-center align-items-center" id="treesummary_expand">
              <div *ngIf="ExpandTreemap">
                <app-treemapsummary-chart [GraphData]="CatSubcatData" [chartContainer]="treesummary_expand"
                  [isExpand]="true">
                </app-treemapsummary-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" id="tabularModal" tabindex="-1" role="dialog" aria-labelledby="expandTit" aria-hidden="true"
      data-bs-backdrop="static">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content iom-modewhite" style="width: 80%;">
          <div class="modal-header">
            <h5 class="modal-title" id="expandTit">Identified Opportunities</h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive iom-newtable">
              <table class="table table-striped table-vmiddle myw-table">
                <thead>
                  <tr>
                    <th scope="col" style="width: 60%;">Category Name</th>
                    <th scope="col" style="text-align: center;width: 20%;">Ticket Count</th>
                    <th scope="col" style="text-align: center;width: 20%;">Ticket %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let d of CatSubcatData">
                    <td>{{d.CategoryName}}</td>
                    <td style="text-align: center;">{{formatNumber(d.TicketCount)}}</td>
                    <td style="text-align: center;">{{d.Percentage}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--model for pareto expended view-->
    <div class="modal" id="paretoExpandModal" tabindex="-1" role="dialog" aria-labelledby="expandTit" aria-hidden="true"
      data-bs-backdrop="static">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content iom-modewhite" style="width: 54rem;">
          <div class="modal-header">
            <h5 class="modal-title" id="expandTit">Total Ticket By Application Name</h5>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div style="margin-left: 38rem;">
              <div class="form-inline mr-2">
                <span>Select Top</span>&nbsp;&nbsp;&nbsp;<select class="form-control control-border"
                  [(ngModel)]="topSelection" (change)="changeSeletion()">
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="40">40</option>
                  <option value="60">60</option>
                  <option value="80">80</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <div class="justify-content-center align-items-center" id="pareto_expand">
              <div *ngIf="keyChartGraphDataExpended">
                <app-pareto-expended [GraphData]="keyChartGraphDataExpended" [chartContainer]="pareto_expand"
                  [topSelection]="topSelection">
                </app-pareto-expended>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="modal-backdrop show"></div> -->
  </div>
